import { render, staticRenderFns } from "./MainMenuAccount.vue?vue&type=template&id=69484238"
import script from "./MainMenuAccount.vue?vue&type=script&lang=js"
export * from "./MainMenuAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports